<template>
    <div class="notice01">
      <Nav :navSelectParent="1" />
    <div class='middle01'>
     <img :src="gxbg" alt="" class='gxbg'>
     <img :src="gxtitle" alt="" class='gxtitle'>
     <img :src="bgdi" alt="" class='bgdi'>
     <div class='feiji'>
         <h1 style='font-size:36px;color:#fff;margin-bottom:40px; text-align:center' class='biaot'>【攻略】萌新宝典√ 前期游戏小技巧</h1>
         <div class='dise'>
             <p>1.挂机收益和快速战斗尽量留到队伍等级不够继续挑战主线副本时再领取，这样能够最大化收益。</p>
             <p>2.前期尽量培养初始品质为SSR的卡牌。在同样的品质下，初始品质为SSR的卡牌会比初始品质为SR的卡牌品质更高一些。</p>
             <p>3.初始品质为SR的卡牌可以进行突破至SSR+或SSSR+，作为其他卡牌的突破材料使用。</p>
             <p>4.如果培养了某张卡牌之后后悔了，可以对该卡牌进行重生，花费少量钻石，将其重置为1级，返还所有的消耗金币、英雄经验、进阶石。</p>
             <p>5.红包：在条件允许的情况下，尽可能挑选卡牌突破的红包领取，性价比最高。</p>
             <p>6.前期品质提升带来的属性加成会比上阵同阵营的卡牌更多，所以可以每个阵营的卡牌都练一练。</p>
             <p>7.在进行卡牌突破时，尽量不使用初始品质为SSR的卡牌作为突破材料，这样后期发展会更加顺利。</p>
             <p>8.特权中的“梦境高级特权”和“梦境特级特权”可以使用钻石购买，并永久生效。购买还会赠送高招卡和梦境刷新卷，性价比很高。</p>
             <p>9.前期珍宝屋每天刷新次数建议用完。</p>
             <p>10.推荐购买：进阶石、元素召唤石、高招卡、普招卡、寻宝卷、挑战卷、英雄经验、SSR碎片。</p>
             <p>11.视情况而定：SR碎片。</p>
             <p>12.前期不推荐购买：装备。</p>
             <p>13.命运之塔可以无限次尝试挑战，在差一点就可以通关时可以反复挑战拼运气。</p>
         </div>
     </div>
    </div>
     <div class='gankebottom'>
        <div class='ganke'><img :src="ganke" alt=""></div>
        <div class='btnContent'>
          <div><p>未成年人家长监护工程&nbsp;&nbsp;</p><P>网络游戏出版物号（ISBN）ISBN 978-7-498-07262-7</P></div>
            <div><p>审批文号：国新出审[2020]174 号&nbsp;&nbsp;</p><a href='screct.html'>隐私协议 |&nbsp;&nbsp;</a><a href='https://sdk.djsh5.com/h5game/user/agreement.html'>用户协议 |&nbsp;&nbsp;</a><a href="https://sdk.djsh5.com/h5game/user/antiaddiction.html">防沉迷系统&nbsp;&nbsp;</a><P>来文文号：津新出字[2019]232 号</P></div>
            <div><p>地址：上海市徐汇区虹漕路88号越虹广场B座6楼&nbsp;&nbsp;</p><p>电话：021-64660150&nbsp;&nbsp;</p><P>Email：bd@gank-studio.com</P></div>
            <div><p>抵制不良游戏，拒绝盗z版游戏。 注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。</p></div>
        </div>
     </div>
    </div>
  </template>
<script>
import Nav from '../components/nav.vue'
export default {
  name: 'notice01',
  components: {
    Nav
  },
  data () {
    return {
      ganke: require('../assets/ganke.png'),
      imgUrl: require('../assets/nav.png'),
      leftIcon: require('../assets/icon.png'),
      shouter: require('../assets/shouted.png'),
      introduction: require('../assets/introduction.png'),
      characteristic: require('../assets/characteristic.png'),
      gxbg: require('../assets/gxbg.png'),
      gxtitle: require('../assets/gxtitle.png'),
      bgdi: require('../assets/bgdi.png')
    }
  }
}
</script>

<style scoped>
.imgUrl {
  position:absolute;
  width:100%;
  height:88px;
  line-height:88px;
}
.row {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  height:88px;
  padding:0 10%;
  box-sizing: content-box;
}
.iconUl {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  box-sizing: content-box;
}
ul li {
  list-style: none;
}
.bottom {
  width:100vw;
  padding:50px 0;
  background-color:#000;
  display:flex;
  flex-direction: column;
  align-items: center;
  color:#fff
}
.bottom div {
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  font-size:22px;
}
.middle01 {
  position:relative;
}
.gxbg {
  position:relative;
  width:100vw;
}
.gxtitle {
    position:absolute;
    top:40%;
    left:50%;
    margin-left:-580px;
}
.bgdi {
    position:absolute;
    top:55%;
    left:50%;
    margin-left:-668px;
}
.feiji {
    position:absolute;
    top:60%;
    width:60%;
    left:20%;
}
.dise {
    width:100%;
    max-height:350px;
    overflow:scroll;
    background-color:#eee9e0;
    font-size:22px;
    color:#000;
    padding:30px 0
}
.dise p {
    display:block;
    line-height:42px;
    padding:0 25px;

}
.gankebottom {
  width:100vw;
  padding:50px 0;
  background-color:#000;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#fff;
  margin-top:-15px;
}
.btnContent {
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size:18px;
}
.btnContent div {
  display:flex;
  flex-direction: row;
}
.btnContent a {
  color: rgb(250, 171, 25);
  cursor: pointer;
}
.ganke {
  margin-right:30px
}
.ganke img{
  width:152px;
  height:60px;
}
@media screen and (max-width: 1300px) {
  .bgdi {
    position: absolute;
    top: 55%;
    width: 80%;
    left: 63% !important;
    height: 525px !important;
}
.feiji {
  top:58%
}
.dise {
  height:350px;
  font-size:20px;
}
.biaot {
  font-size:30px !important;
  margin-bottom:10px !important
}
.gxtitle{
    position: absolute;
    top: 44%;
    left: 25%;
    width: 50%;
    margin-left:0
}
}
</style>



// WEBPACK FOOTER //
// src/pages/notice01.vue